import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SearchProductComponent } from './search-product.component';
import { I18nModule, provideConfig } from '@spartacus/core';
import { searchProductOccConfig } from './core/serach-product.occ';
import { ReactiveFormsModule } from '@angular/forms';
import { FormErrorsModule } from '@spartacus/storefront';
import { ProductItemComponent } from './components/product-item/product-item.component';
import { LocalLoaderComponent } from '../loader/local-loader/local-loader.component';

@NgModule({
  declarations: [SearchProductComponent],
  imports: [
    CommonModule,
    ReactiveFormsModule,
    FormErrorsModule,
    I18nModule,
    ProductItemComponent,
    LocalLoaderComponent,
  ],
  exports: [SearchProductComponent],
  providers: [provideConfig(searchProductOccConfig)],
})
export class SearchProductModule {}
